package com.eladfinish.bible.contest.screens.mikud.usecases

import com.eladfinish.bible.contest.domain.catalog.BibleCatalog
import com.eladfinish.bible.contest.extensions.convertToDataClass
import com.eladfinish.bible.contest.screens.mikud.model.LocalMikudMap
import com.eladfinish.bible.contest.screens.mikud.model.MikudData
import io.github.aakira.napier.Napier
import kotlinx.collections.immutable.toImmutableList
import kotlin.time.measureTime

class ParseMikudFromFileUseCase(
    private val populateBookUseCase: PopulateBookUseCase,
    private val buildBooksListUseCase: BuildBooksListUseCase,
) {

    operator fun invoke(text: String): MikudData {
        val mikud = buildBooksListUseCase(full = false).toMutableList()
        measureTime {
            val mikudListFromFile = text.convertToDataClass<LocalMikudMap>().toList()
            val bibleBooksEng = BibleCatalog.books.map { it.trans }
            mikudListFromFile.forEach { pair ->
                val index = bibleBooksEng.indexOf(pair.first)
                val chapters = pair.second
                populateBookUseCase(mikud = mikud, index = index, chapters = chapters)
            }
        }.also {
            Napier.d("duration: $it")
        }
        return mikud.toImmutableList()
    }
}
